import React from "react";
import { NavLink, Link, Outlet } from "react-router-dom";
import { GAMES_BY_TIME } from "../data/games";
import { SITE_NAME } from "../data/site";

const NAV_LINKS = [
  { to: "/", label: "HOME", end: true },
  { to: "/satta-chart", label: "CHART" },
  { to: "/faq", label: "FAQ" },
  { to: "/contact-us", label: "CONTACT" },
];

/**
 * Shell shared by every route.
 *
 * The footer carries a link to all ten game pages on purpose: it is the
 * internal-linking layer that lets crawlers reach every deep page from any
 * entry point, which is what gets long-tail pages discovered and indexed.
 */
const Layout = () => {
  const year = new Date().getFullYear();

  return (
    <div className="app-root">
      <nav className="nav" aria-label="Primary">
        <div className="container">
          <div className="nav-grid">
            {NAV_LINKS.map((link) => (
              <NavLink
                key={link.to}
                to={link.to}
                end={link.end}
                className={({ isActive }) =>
                  `nav-btn ${isActive ? "active" : ""}`
                }
              >
                {link.label}
              </NavLink>
            ))}
          </div>
        </div>
      </nav>

      <main className="app-main">
        <Outlet />
      </main>

      <footer className="footer">
        <div className="container footer-inner">
          <nav className="footer-links" aria-label="All game results">
            <h2 className="footer-heading">Satta Result Pages</h2>
            <ul>
              {GAMES_BY_TIME.map((game) => (
                <li key={game.key}>
                  <Link to={`/${game.slug}`}>
                    {game.name} Satta Result
                    <span className="footer-time"> · {game.timeLabel}</span>
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <nav className="footer-links footer-links-inline" aria-label="Site">
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/satta-chart">Satta Chart</Link></li>
              <li><Link to="/faq">FAQ</Link></li>
              <li><Link to="/about-us">About Us</Link></li>
              <li><Link to="/contact-us">Contact Us</Link></li>
              <li><Link to="/disclaimer">Disclaimer</Link></li>
              <li><Link to="/privacy-policy">Privacy Policy</Link></li>
              <li><Link to="/terms-and-conditions">Terms &amp; Conditions</Link></li>
            </ul>
          </nav>

          <p className="footer-note">
            © {year} {SITE_NAME} — All Rights Reserved.
          </p>
          <p className="footer-note">
            Daily result charts for Disawar, Bagad, Delhi Bazar, Shri Ganesh,
            Faridabad, Jai Bhawani, Ghaziabad, Jai Hanuman, Gogamedi and Gali.
          </p>
          <p className="footer-note footer-disclaimer">
            For informational purposes only. Satta and gambling are illegal in
            many Indian states. Please follow the law in your region — see our{" "}
            <Link to="/disclaimer">full disclaimer</Link>.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default Layout;
